// removed by extract-text-webpack-plugin
module.exports = {"base":"Info_base--IkZ2f"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Info/Info.css
// module id = 1786
// module chunks = 16